<section class="static-page">
  <header class="static-header">
    <span class="static-icon" aria-hidden="true"><i class="fa-solid fa-users"></i></span>
    <h1>Our Customers</h1>
    <p class="static-subtitle">Businesses running on orderYaa ERP.</p>
  </header>

  <div class="container">
    <div class="static-content">
      <p>
        orderYaa is used by retail stores, restaurants, wholesalers, and small manufacturers who
        need their sales, stock, and books to stay in sync — without hiring a full IT team to
        manage it.
      </p>

      <h2>Where orderYaa fits</h2>
      <ul>
        <li><strong>Retail &amp; POS</strong> — single and multi-branch stores running billing, stock, and reporting together</li>
        <li><strong>Restaurants &amp; food</strong> — counter sales, online ordering, and delivery in one system</li>
        <li><strong>Wholesale &amp; distribution</strong> — vendor management, purchase orders, and multi-warehouse inventory</li>
        <li><strong>Light manufacturing</strong> — work centers, standard costing, and production tracking</li>
      </ul>

      <h2>Why they stay</h2>
      <p>
        Customers tell us the same thing: everything — sales, inventory, accounting, and HR — is
        finally in one place, so numbers match without end-of-month reconciliation.
      </p>

      <h2>Want to be featured?</h2>
      <p>
        If you're running your business on orderYaa and want to share your story, we'd love to
        hear it — email us at <a href="https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=hr@techcolleagues.com" target="_blank" rel="noopener noreferrer">hr&#64;techcolleagues.com</a>.
      </p>
    </div>
  </div>
</section>
